// Books is a client-side app (adapter-static with an SPA fallback): every page
// needs the signed-in session, which lives in the browser.
export const ssr = false;
export const prerender = false;
